// FaqPage.js
import React from 'react';
import './Faqs.css';

const faqs = [
  {
    question: 'What is the relationship between diabetes and hypertension?',
    answer: 'Diabetes and hypertension often occur together. High blood sugar levels can damage blood vessels, which can increase blood pressure. Similarly, high blood pressure strains the heart and kidneys, increasing the risk of complications in people with diabetes.'
  },
  {
    question: 'Why does diabetes affect the feet and not the hands?',
    answer: 'Diabetes can damage blood vessels and nerves, especially in the lower limbs. Feet are farther from the heart and more prone to poor circulation and nerve damage (neuropathy), making them more vulnerable to ulcers, infections, and delayed healing.'
  },
  {
    question: 'What is the effect of alcohol and smoking on diabetes and hypertension?',
    answer: 'Alcohol and smoking worsen both conditions. Alcohol can raise blood pressure and interfere with blood sugar control. Smoking damages blood vessels, increases blood pressure, and reduces oxygen delivery, heightening the risk of heart attack and stroke in patients with diabetes or hypertension.'
  },
  {
    question: 'Why are we advised to take red meat only twice a week?',
    answer: 'Excessive red meat consumption is linked to increased risk of heart disease, hypertension, and insulin resistance. Limiting intake reduces saturated fats and helps manage cholesterol, weight, and blood pressure.'
  },
  {
    question: 'How much water should we drink daily, and when?',
    answer: 'An average adult should drink 6–8 glasses (about 1.5 to 2 litres) of water daily. Water should be consumed throughout the day — especially before meals, after exercise, and when you feel thirsty — to support metabolism, kidney health, and blood volume regulation.'
  },
  {
    question: 'Can diabetes and hypertension be reversed or cured?',
    answer: 'While not “curable” in most cases, both conditions can be managed — and in some early cases, reversed — through lifestyle changes like diet, exercise, stress management, and consistent medical follow-up.'
  },
  {
    question: 'What are early signs of diabetes and hypertension?',
    answer: 'Early diabetes signs include frequent urination, fatigue, blurred vision, and increased thirst. Hypertension often has no symptoms but may include headaches, dizziness, or blurred vision in severe cases — hence the nickname “silent killer.”'
  },
  {
    question: 'How does stress affect blood pressure and blood sugar?',
    answer: 'Chronic stress can raise both blood pressure and blood sugar levels by releasing stress hormones like cortisol, which increase insulin resistance and blood vessel tension.'
  },
  {
    question: 'Is fruit safe for people with diabetes?',
    answer: 'Yes, fruits are safe in moderation. Whole fruits (not juices) provide fiber and nutrients. However, high-sugar fruits like mangoes or pineapples should be limited. Portion size and balance are key.'
  },
  {
    question: 'How often should one get screened for diabetes and hypertension?',
    answer: 'Adults over 35 or those with risk factors should be screened annually. If you have a family history, are overweight, or have had gestational diabetes or high blood pressure, earlier and more frequent screenings are recommended.'
  }
];

const FaqPage = () => {
  return (
    <div className="faq-container">
      <h2>Frequently Asked Questions (FAQs)</h2>
      <p className="intro">Your health questions, answered with clarity.</p>
      <div className="faq-list">
        {faqs.map((item, index) => (
          <div key={index} className="faq-item">
            <h4 className="faq-question">{item.question}</h4>
            <p className="faq-answer">{item.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqPage;
